import { render, staticRenderFns } from "./ExemptionCard.vue?vue&type=template&id=8583b040&scoped=true"
import script from "./ExemptionCard.vue?vue&type=script&lang=js"
export * from "./ExemptionCard.vue?vue&type=script&lang=js"
import style0 from "./ExemptionCard.vue?vue&type=style&index=0&id=8583b040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8583b040",
  null
  
)

export default component.exports